import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-privacy-ic',
  templateUrl: './icon-privacy-ic.component.html',
  styleUrls: ['./icon-privacy-ic.component.scss']
})
export class IconPrivacyIcComponent implements OnInit {
  @Input() color = '#D0D0D0';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
